import { ChipComponent } from './chip.component';

export default angular
  .module('sfMobile.components.chip', [])
  .component('sfChip', ChipComponent).name;
